(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[577],{

/***/ 72951:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/auth/sign-in",
      function () {
        return __webpack_require__(52031);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 52031:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* reexport */ SignInPage; }
});

// EXTERNAL MODULE: ../../node_modules/.pnpm/react@18.2.0/node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(97458);
// EXTERNAL MODULE: ../../node_modules/.pnpm/react@18.2.0/node_modules/react/index.js
var react = __webpack_require__(52983);
// EXTERNAL MODULE: ../../packages/ui/src/blocks/layout/site-layout.tsx + 2 modules
var site_layout = __webpack_require__(65747);
// EXTERNAL MODULE: ../../node_modules/.pnpm/clsx@1.2.1/node_modules/clsx/dist/clsx.m.js
var clsx_m = __webpack_require__(14517);
// EXTERNAL MODULE: ../../node_modules/.pnpm/next-auth@4.10.3_znuz5irtsx3b6gfuzekl2h7mzq_biqbaboplfbrettd7655fr4n2y/node_modules/next-auth/react/index.js
var next_auth_react = __webpack_require__(63861);
// EXTERNAL MODULE: ../../packages/ui/src/components/alert/alert.tsx
var alert_alert = __webpack_require__(63431);
// EXTERNAL MODULE: ../../packages/ui/src/components/button/button.tsx
var button_button = __webpack_require__(51606);
// EXTERNAL MODULE: ../../packages/ui/src/components/divider/divider.tsx
var divider = __webpack_require__(91828);
// EXTERNAL MODULE: ../../packages/ui/src/components/heading/heading.tsx
var heading = __webpack_require__(36609);
// EXTERNAL MODULE: ../../packages/ui/src/components/link/link.tsx
var link_link = __webpack_require__(7278);
// EXTERNAL MODULE: ../../packages/ui/src/components/logo/logo.tsx
var logo = __webpack_require__(49306);
// EXTERNAL MODULE: ../../packages/ui/src/components/text/text.tsx
var text_text = __webpack_require__(47098);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@swc+helpers@0.4.11/node_modules/@swc/helpers/src/_object_spread.mjs + 1 modules
var _object_spread = __webpack_require__(32641);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@swc+helpers@0.4.11/node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(93089);
// EXTERNAL MODULE: ../../packages/utils/src/function.ts
var src_function = __webpack_require__(21163);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@headlessui+react@1.7.3_biqbaboplfbrettd7655fr4n2y/node_modules/@headlessui/react/dist/utils/render.js
var render = __webpack_require__(78314);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@headlessui+react@1.7.3_biqbaboplfbrettd7655fr4n2y/node_modules/@headlessui/react/dist/hooks/use-id.js
var use_id = __webpack_require__(85798);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@headlessui+react@1.7.3_biqbaboplfbrettd7655fr4n2y/node_modules/@headlessui/react/dist/components/keyboard.js
var keyboard = __webpack_require__(74825);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@headlessui+react@1.7.3_biqbaboplfbrettd7655fr4n2y/node_modules/@headlessui/react/dist/utils/bugs.js
var bugs = __webpack_require__(36618);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@headlessui+react@1.7.3_biqbaboplfbrettd7655fr4n2y/node_modules/@headlessui/react/dist/hooks/use-iso-morphic-effect.js
var use_iso_morphic_effect = __webpack_require__(27406);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@headlessui+react@1.7.3_biqbaboplfbrettd7655fr4n2y/node_modules/@headlessui/react/dist/hooks/use-sync-refs.js
var use_sync_refs = __webpack_require__(20169);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@headlessui+react@1.7.3_biqbaboplfbrettd7655fr4n2y/node_modules/@headlessui/react/dist/hooks/use-event.js
var use_event = __webpack_require__(48861);
;// CONCATENATED MODULE: ../../node_modules/.pnpm/@headlessui+react@1.7.3_biqbaboplfbrettd7655fr4n2y/node_modules/@headlessui/react/dist/components/label/label.js
let u=(0,react.createContext)(null);function c(){let o=(0,react.useContext)(u);if(o===null){let t=new Error("You used a <Label /> component, but it is not inside a relevant parent.");throw Error.captureStackTrace&&Error.captureStackTrace(t,c),t}return o}function M(){let[o,t]=(0,react.useState)([]);return[o.length>0?o.join(" "):void 0,(0,react.useMemo)(()=>function(e){let l=(0,use_event/* useEvent */.z)(a=>(t(i=>[...i,a]),()=>t(i=>{let n=i.slice(),d=n.indexOf(a);return d!==-1&&n.splice(d,1),n}))),r=(0,react.useMemo)(()=>({register:l,slot:e.slot,name:e.name,props:e.props}),[l,e.slot,e.name,e.props]);return react.createElement(u.Provider,{value:r},e.children)},[t])]}let h="label",F=(0,render/* forwardRefWithAs */.yV)(function(t,s){let{passive:e=!1,...l}=t,r=c(),a=`headlessui-label-${(0,use_id/* useId */.M)()}`,i=(0,use_sync_refs/* useSyncRefs */.T)(s);(0,use_iso_morphic_effect/* useIsoMorphicEffect */.e)(()=>r.register(a),[a,r.register]);let n={ref:i,...r.props,id:a};return e&&("onClick"in n&&delete n.onClick,"onClick"in l&&delete l.onClick),(0,render/* render */.sY)({ourProps:n,theirProps:l,slot:r.slot||{},defaultTag:h,name:r.name||"Label"})});

// EXTERNAL MODULE: ../../node_modules/.pnpm/@headlessui+react@1.7.3_biqbaboplfbrettd7655fr4n2y/node_modules/@headlessui/react/dist/components/description/description.js
var description = __webpack_require__(11327);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@headlessui+react@1.7.3_biqbaboplfbrettd7655fr4n2y/node_modules/@headlessui/react/dist/hooks/use-resolve-button-type.js
var use_resolve_button_type = __webpack_require__(79912);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@headlessui+react@1.7.3_biqbaboplfbrettd7655fr4n2y/node_modules/@headlessui/react/dist/internal/hidden.js
var internal_hidden = __webpack_require__(95639);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@headlessui+react@1.7.3_biqbaboplfbrettd7655fr4n2y/node_modules/@headlessui/react/dist/utils/form.js
var utils_form = __webpack_require__(71830);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@headlessui+react@1.7.3_biqbaboplfbrettd7655fr4n2y/node_modules/@headlessui/react/dist/hooks/use-controllable.js
var use_controllable = __webpack_require__(27006);
;// CONCATENATED MODULE: ../../node_modules/.pnpm/@headlessui+react@1.7.3_biqbaboplfbrettd7655fr4n2y/node_modules/@headlessui/react/dist/components/switch/switch.js
let switch_h=(0,react.createContext)(null);switch_h.displayName="GroupContext";let z=react.Fragment;function J(b){let[t,o]=(0,react.useState)(null),[i,d]=M(),[a,s]=(0,description/* useDescriptions */.f)(),u=(0,react.useMemo)(()=>({switch:t,setSwitch:o,labelledby:i,describedby:a}),[t,o,i,a]),p={},m=b;return react.createElement(s,{name:"Switch.Description"},react.createElement(d,{name:"Switch.Label",props:{onClick(){!t||(t.click(),t.focus({preventScroll:!0}))}}},react.createElement(switch_h.Provider,{value:u},(0,render/* render */.sY)({ourProps:p,theirProps:m,defaultTag:z,name:"Switch.Group"}))))}let Q="button",V=(0,render/* forwardRefWithAs */.yV)(function(t,o){let{checked:i,defaultChecked:d=!1,onChange:a,name:s,value:u,...p}=t,m=`headlessui-switch-${(0,use_id/* useId */.M)()}`,r=(0,react.useContext)(switch_h),y=(0,react.useRef)(null),P=(0,use_sync_refs/* useSyncRefs */.T)(y,o,r===null?null:r.setSwitch),[n,f]=(0,use_controllable/* useControllable */.q)(i,a,d),T=(0,use_event/* useEvent */.z)(()=>f==null?void 0:f(!n)),v=(0,use_event/* useEvent */.z)(e=>{if((0,bugs/* isDisabledReactIssue7711 */.P)(e.currentTarget))return e.preventDefault();e.preventDefault(),T()}),k=(0,use_event/* useEvent */.z)(e=>{e.key===keyboard/* Keys.Space */.R.Space?(e.preventDefault(),T()):e.key===keyboard/* Keys.Enter */.R.Enter&&(0,utils_form/* attemptSubmit */.g)(e.currentTarget)}),g=(0,use_event/* useEvent */.z)(e=>e.preventDefault()),C=(0,react.useMemo)(()=>({checked:n}),[n]),D={id:m,ref:P,role:"switch",type:(0,use_resolve_button_type/* useResolveButtonType */.f)(t,y),tabIndex:0,"aria-checked":n,"aria-labelledby":r==null?void 0:r.labelledby,"aria-describedby":r==null?void 0:r.describedby,onClick:v,onKeyUp:k,onKeyPress:g};return react.createElement(react.Fragment,null,s!=null&&n&&react.createElement(internal_hidden/* Hidden */._,{features:internal_hidden/* Features.Hidden */.A.Hidden,...(0,render/* compact */.oA)({as:"input",type:"checkbox",hidden:!0,readOnly:!0,checked:n,name:s,value:u})}),(0,render/* render */.sY)({ourProps:D,theirProps:p,slot:C,defaultTag:Q,name:"Switch"}))}),be=Object.assign(V,{Group:J,Label:F,Description:description/* Description */.d});

;// CONCATENATED MODULE: ../../packages/ui/src/components/toggle/toggle.tsx








function Toggle(param) {
    let { checked , label , labelProps , onChange , reverse , className , disabled , hintText  } = param;
    const handleMoudDown = react.useCallback((e)=>e.preventDefault(), []);
    const disabledStyle = disabled ? "cursor-not-allowed" : "cursor-pointer";
    const memoLabel = react.useMemo(()=>/*#__PURE__*/ (0,jsx_runtime.jsxs)(be.Label, {
            className: (0,clsx_m/* default */.Z)(disabledStyle),
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(text_text/* Text */.x, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                    size: "sm"
                }, labelProps), {
                    className: "font-semibold",
                    children: label
                })),
                hintText && /*#__PURE__*/ (0,jsx_runtime.jsx)(text_text/* Text */.x, {
                    variant: "secondary",
                    size: "sm",
                    children: hintText
                })
            ]
        }, "label"), [
        disabledStyle,
        hintText,
        label,
        labelProps
    ]);
    const memoSwitch = react.useMemo(()=>/*#__PURE__*/ (0,jsx_runtime.jsx)(be, {
            checked: checked,
            onChange: disabled ? src_function/* noop */.Z : onChange,
            onMouseDown: handleMoudDown,
            className: (0,clsx_m/* default */.Z)(!disabled ? checked ? "bg-primary-900 hover:bg-primary-1000" : "bg-gray-400 hover:bg-gray-500" : "bg-gray-400", disabledStyle, "relative inline-flex h-5 w-9 flex-shrink-0 rounded-full border-2 border-transparent transition duration-200 ease-in-out focus-visible:outline-none focus-visible:ring focus-visible:ring-primary-500"),
            children: (param)=>/*#__PURE__*/ {
                let { checked  } = param;
                return (0,jsx_runtime.jsx)("span", {
                    className: (0,clsx_m/* default */.Z)(checked ? "translate-x-4" : "translate-x-0", disabled ? "bg-gray-100" : "bg-white ", "inline-block h-4 w-4 rounded-full shadow-sm transition duration-200 ease-in-out")
                });
            }
        }, "switch"), [
        checked,
        disabled,
        onChange,
        handleMoudDown,
        disabledStyle
    ]);
    const memoElements = react.useMemo(()=>reverse ? [
            memoSwitch,
            memoLabel
        ] : [
            memoLabel,
            memoSwitch
        ], [
        reverse,
        memoSwitch,
        memoLabel
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(be.Group, {
        as: "div",
        className: (0,clsx_m/* default */.Z)("flex w-full flex-row items-start space-x-2", className),
        children: memoElements
    });
}

;// CONCATENATED MODULE: ../../packages/ui/src/strings/index.ts
const SIGN_IN_ERRORS = {
    Signin: "Try signing in with a different account.",
    OAuthSignin: "Try signing in with a different account.",
    OAuthCallback: "Try signing in with a different account.",
    OAuthCreateAccount: "Try signing in with a different account.",
    EmailCreateAccount: "Try signing in with a different account.",
    Callback: "Try signing in with a different account.",
    OAuthAccountNotLinked: "To confirm your identity, sign in with the same account you used originally.",
    EmailSignin: "Check your email inbox.",
    CredentialsSignin: "Sign in failed. Check the details you provided are correct.",
    Default: "Unable to sign in."
};

// EXTERNAL MODULE: ../../packages/ui/src/blocks/footer/footer.tsx + 1 modules
var footer = __webpack_require__(43965);
// EXTERNAL MODULE: ../../packages/ui/src/components/text-field/text-field.tsx
var text_field = __webpack_require__(54347);
// EXTERNAL MODULE: ../../packages/ui/src/hooks/use-form/use-form.ts + 1 modules
var use_form = __webpack_require__(57543);
;// CONCATENATED MODULE: ../../packages/ui/src/blocks/sign-in-form/anonymous-user-sign-in.tsx










function AnonymousUserSignIn(param) {
    let { children  } = param;
    const { register , handleSubmit , errors  } = (0,use_form/* useForm */.c)({
        defaultValues: {
            name: ""
        }
    });
    const handleClickSubmit = handleSubmit(async (fields, event)=>{
        event.preventDefault();
        await (0,next_auth_react.signIn)("credentials", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, fields), {
            callbackUrl: "".concat(location.origin, "/auth/redirecting")
        }));
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("form", {
        onSubmit: handleClickSubmit,
        className: "space-y-4",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(text_field/* TextField */.n, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, register("name", {
                pattern: {
                    value: /^[\w ]{3,24}$/,
                    message: "Name can only have alphabets, numbers, _ or empty spaces, and it must be 3-24 characters long"
                }
            })), {
                errorMessage: errors === null || errors === void 0 ? void 0 : errors.name,
                type: "text",
                label: "Name",
                className: "w-full",
                placeholder: "James Smith"
            })),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                children: [
                    children,
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(button_button/* Button */.z, {
                        type: "submit",
                        variant: "solid",
                        color: "primary",
                        className: "w-full",
                        children: "Continue as anonymous user"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(text_text/* Text */.x, {
                size: "sm",
                variant: "secondary",
                children: [
                    "You can connect an email later, or stay anonymous as long as you like. Learn more about",
                    " ",
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(link_link/* Link */.r, {
                        href: "/docs/features/privacy-friendly#anonymous-sign-in",
                        children: "anonymous sign-in"
                    }),
                    "."
                ]
            })
        ]
    });
}

// EXTERNAL MODULE: ../../packages/ui/src/utilities/validator.ts
var validator = __webpack_require__(6460);
;// CONCATENATED MODULE: ../../packages/ui/src/blocks/sign-in-form/email-sign-in.tsx











/**
 * Email/magic link sign-in
 */ function EmailSignIn(param) {
    let { children  } = param;
    const { register , handleSubmit , errors  } = (0,use_form/* useForm */.c)({
        defaultValues: {
            email: ""
        }
    });
    const handleClickSubmit = handleSubmit(async (fields, event)=>{
        event.preventDefault();
        await (0,next_auth_react.signIn)("email", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, fields), {
            callbackUrl: "".concat(location.origin, "/auth/redirecting")
        }));
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("form", {
        onSubmit: handleClickSubmit,
        className: "space-y-4",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(text_field/* TextField */.n, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, register("email", {
                pattern: {
                    value: validator/* EMAIL_REGEXP */.i,
                    message: "Invalid email address"
                }
            })), {
                errorMessage: errors === null || errors === void 0 ? void 0 : errors.email,
                type: "text",
                label: "Email",
                className: "w-full",
                placeholder: "james@example.com"
            })),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                children: [
                    children,
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(button_button/* Button */.z, {
                        type: "submit",
                        variant: "solid",
                        color: "primary",
                        className: "w-full",
                        children: "Continue with email"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(text_text/* Text */.x, {
                size: "sm",
                variant: "secondary",
                children: [
                    "You can sign-in without password by using a temporary Access Code sent to your email instead. Learn more about",
                    " ",
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(link_link/* Link */.r, {
                        href: "/docs/features/privacy-friendly#email-sign-in",
                        children: "email sign-in"
                    }),
                    "."
                ]
            })
        ]
    });
}

// EXTERNAL MODULE: ../../packages/ui/src/blocks/sign-in-form/sign-in-form.module.scss
var sign_in_form_module = __webpack_require__(22357);
var sign_in_form_module_default = /*#__PURE__*/__webpack_require__.n(sign_in_form_module);
;// CONCATENATED MODULE: ../../node_modules/.pnpm/super-tiny-icons@0.4.0/node_modules/super-tiny-icons/images/svg/github.svg
/* harmony default export */ var github = ({"src":"/_next/static/media/github.63fcb863.svg","height":512,"width":512});
;// CONCATENATED MODULE: ../../node_modules/.pnpm/super-tiny-icons@0.4.0/node_modules/super-tiny-icons/images/svg/twitter.svg
/* harmony default export */ var twitter = ({"src":"/_next/static/media/twitter.f374da7d.svg","height":512,"width":512});
// EXTERNAL MODULE: ../../packages/ui/src/hooks/use-async.ts + 2 modules
var use_async = __webpack_require__(84805);
;// CONCATENATED MODULE: ../../packages/ui/src/blocks/sign-in-form/use-social-auth-options.tsx





// import FacebookLogo from 'super-tiny-icons/images/svg/facebook.svg';
// import GoogleLogo from 'super-tiny-icons/images/svg/google.svg';
function useSocialAuthOptions() {
    const { data  } = (0,use_async/* useAsync */.r)(next_auth_react.getProviders, true);
    if (!data) {
        return null;
    }
    return Object.values(data).map((val)=>{
        const option = AUTH_OPTIONS[val.id];
        if (!option) {
            return false;
        }
        return option;
    }).filter(Boolean);
}
const AUTH_OPTIONS = {
    // TODO: Make google sign-in work
    // {
    //   name: 'Google',
    //   icon: getLogoComponent(GoogleLogo, 'google', 26),
    // },
    // TODO: add back facebook login once we can delete user account.
    // {
    //   name: 'Facebook',
    //   icon: getLogoComponent(FacebookLogo, 'facebook', 24),
    // },
    twitter: {
        name: "Twitter",
        icon: getLogoComponent(twitter, "twitter", 24)
    },
    github: {
        name: "GitHub",
        icon: getLogoComponent(github, "github", 24)
    }
};
function getLogoComponent(data, brand, size) {
    return function SocialLogo() {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
            src: data.src,
            width: size,
            height: size,
            alt: "Logo of ".concat(brand)
        });
    };
}

;// CONCATENATED MODULE: ../../packages/ui/src/blocks/sign-in-form/sign-in-form.tsx


















function SignInForm(param) {
    let { title , subtitle , allowAnonymous  } = param;
    const [errorType, setErrorType] = react.useState(null);
    react.useEffect(()=>{
        const error = new URLSearchParams(location.search).get("error");
        if (error) {
            setErrorType(error);
        }
    }, []);
    var _errorType;
    const error = errorType && ((_errorType = SIGN_IN_ERRORS[errorType]) !== null && _errorType !== void 0 ? _errorType : SIGN_IN_ERRORS.Default);
    const [isAnonymous, setIsAnonymous] = react.useState(true);
    const alert = react.useMemo(()=>error && /*#__PURE__*/ (0,jsx_runtime.jsx)(alert_alert/* Alert */.b, {
            onClickDismiss: ()=>setErrorType(null),
            type: "warn",
            title: error,
            styles: {
                root: "mb-1 py-2 px-4",
                // Force row direction
                container: "!space-x-2 !flex-row !space-y-0",
                dismissButton: "mt-0.5"
            },
            align: "center"
        }, "alert"), [
        error
    ]);
    const authOptions = useSocialAuthOptions();
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "full-bleed flex h-full flex-row",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "flex h-full flex-1 flex-col items-center ",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "mt-8 ml-0 self-start justify-self-end sm:ml-8",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(logo/* Logo */.T, {
                            size: "lg",
                            hideSpacing: true
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "flex h-full w-full flex-col justify-center space-y-8 py-7 sm:mx-2 sm:w-64 md:w-96",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "space-y-3",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(heading/* Heading */.X, {
                                        as: "h2",
                                        className: "mt-5 font-bold",
                                        children: title
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(text_text/* Text */.x, {
                                        variant: "secondary",
                                        children: subtitle
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "space-y-6",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        children: [
                                            allowAnonymous && isAnonymous ? /*#__PURE__*/ (0,jsx_runtime.jsx)(AnonymousUserSignIn, {
                                                children: alert
                                            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(EmailSignIn, {
                                                children: alert
                                            }),
                                            allowAnonymous && /*#__PURE__*/ (0,jsx_runtime.jsx)(Toggle, {
                                                checked: isAnonymous,
                                                onChange: (value)=>setIsAnonymous(value),
                                                label: "Anonymous",
                                                reverse: true,
                                                className: "mt-6",
                                                hintText: "Turn off to sign in with your email if you want to sign-in with another browser later."
                                            })
                                        ]
                                    }),
                                    authOptions && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(divider/* Divider */.i, {
                                                variant: "text",
                                                children: "OR"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "space-y-3",
                                                children: authOptions === null || authOptions === void 0 ? void 0 : authOptions.map((option)=>/*#__PURE__*/ (0,jsx_runtime.jsxs)(button_button/* Button */.z, {
                                                        onClick: ()=>(0,next_auth_react.signIn)(option.name.toLowerCase(), {
                                                                callbackUrl: "".concat(location.origin, "/auth/redirecting")
                                                            }),
                                                        className: "w-full px-0 md:justify-start md:pl-20",
                                                        size: "lg",
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(option.icon, {}),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                                className: "ml-2 text-left",
                                                                children: [
                                                                    "Sign in with ",
                                                                    option.name
                                                                ]
                                                            })
                                                        ]
                                                    }, option.name))
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(text_text/* Text */.x, {
                                className: "py-3",
                                size: "sm",
                                variant: "secondary",
                                children: [
                                    "By clicking the buttons above, you acknowledge that you have read\n            and understood, and agree to Chirpy's ",
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(link_link/* Link */.r, {
                                        href: "/terms-of-service",
                                        children: "Terms of Service"
                                    }),
                                    " and ",
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(link_link/* Link */.r, {
                                        href: "/privacy-policy",
                                        children: "Privacy Policy"
                                    }),
                                    "."
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "mb-8 ml-0 self-start justify-self-end sm:ml-8",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(footer/* CompanyRight */.U, {})
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (0,clsx_m/* default */.Z)("hidden h-[100vh] min-h-[200px] w-full flex-1 bg-cover sm:block", (sign_in_form_module_default()).mainImage)
            })
        ]
    });
}

;// CONCATENATED MODULE: ../../packages/ui/src/pages/auth/sign-in.tsx



function SignInPage() {
    const [allowAnonymous, setAllowAnonymous] = react.useState(false);
    react.useEffect(()=>{
        if (new URL(location.href).searchParams.get("allowAnonymous") === "true") {
            setAllowAnonymous(true);
        }
    }, []);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(site_layout/* default */.Z, {
        title: "Sign in",
        styles: {
            container: "mx-2 md:mx-0 py-0"
        },
        hideFooter: true,
        hideHeader: true,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SignInForm, {
            title: "Sign in",
            subtitle: "\uD83D\uDC4B Welcome! Please enter your details.",
            allowAnonymous: allowAnonymous
        })
    });
}

;// CONCATENATED MODULE: ./src/pages/auth/sign-in.tsx



/***/ }),

/***/ 63431:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "b": function() { return /* binding */ Alert; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(97458);
/* harmony import */ var clsx__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(14517);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(52983);
/* harmony import */ var _button__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(6306);
/* harmony import */ var _icons__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(12953);
/* harmony import */ var _icons__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(41356);
/* harmony import */ var _icons__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(25177);





function Alert(props) {
    var ref, ref1, ref2;
    const [style, Icon, iconButtonColor] = TYPE_STYLES[props.type];
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("section", {
        className: (0,clsx__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)("group relative flex w-full flex-row items-start justify-between rounded border p-4", style, (ref = props.styles) === null || ref === void 0 ? void 0 : ref.root),
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: (0,clsx__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)("flex flex-1 flex-col items-start space-y-3 sm:flex-row sm:space-y-0 sm:space-x-3", props.align === "center" ? "justify-center" : "justify-start", (ref1 = props.styles) === null || ref1 === void 0 ? void 0 : ref1.container),
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Icon, {
                        size: 20,
                        className: ""
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: "",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h4", {
                                className: "text-base font-semibold leading-tight",
                                children: props.title
                            }),
                            props.content && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                className: "mt-1",
                                children: props.content
                            })
                        ]
                    })
                ]
            }),
            !props.hideDismissButton && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_button__WEBPACK_IMPORTED_MODULE_3__/* .IconButton */ .h, {
                className: (0,clsx__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)("invisible group-hover:visible", (ref2 = props.styles) === null || ref2 === void 0 ? void 0 : ref2.dismissButton),
                onClick: props.onClickDismiss,
                "aria-label": "Dismiss",
                color: iconButtonColor,
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_icons__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                    size: 18
                })
            })
        ]
    });
}
const TYPE_STYLES = {
    warn: [
        "bg-yellow-300 text-yellow-1100 border-yellow-600",
        _icons__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z,
        "yellow", 
    ],
    info: [
        "bg-primary-300 text-primary-1100 border-primary-600",
        _icons__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z,
        "primary", 
    ],
    success: [
        "bg-green-300 text-green-1100 border-green-600",
        _icons__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z,
        "green", 
    ]
};


/***/ }),

/***/ 54347:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "n": function() { return /* binding */ TextField; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(32641);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(93089);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(59106);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(97458);
/* harmony import */ var clsx__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(14517);
/* harmony import */ var framer_motion__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(76024);
/* harmony import */ var framer_motion__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(76318);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(52983);
/* harmony import */ var _styles_common__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(55161);
/* harmony import */ var _animation__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(73420);
/* harmony import */ var _text_text__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(47098);










const TextField = /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_1__.forwardRef(function TextfieldComponent(_param, ref) {
    var { label , type ="text" , styles ={} , className , errorMessage , prefixNode , hintText  } = _param, inputProps = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_param, [
        "label",
        "type",
        "styles",
        "className",
        "errorMessage",
        "prefixNode",
        "hintText"
    ]);
    const LabelWrapper = typeof label === "string" ? "p" : "div";
    const { disabled  } = inputProps;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("label", {
        className: (0,clsx__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)("flex flex-col px-0.5 text-gray-1200", styles === null || styles === void 0 ? void 0 : styles.root),
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(LabelWrapper, {
                className: "mb-1.5 text-lg font-semibold leading-6",
                children: label
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: (0,clsx__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(prefixNode && "flex flex-row items-stretch"),
                children: [
                    prefixNode && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "flex flex-row items-center rounded-l border-t border-b border-l px-3",
                        children: prefixNode
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("input", (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({
                        autoComplete: "off"
                    }, inputProps), {
                        ref: ref,
                        type: type,
                        className: (0,clsx__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)("px-3 py-2", disabled && "bg-gray-300 text-gray-1100", _styles_common__WEBPACK_IMPORTED_MODULE_6__/* .textInput */ .Y2, _styles_common__WEBPACK_IMPORTED_MODULE_6__/* .border */ .Cg, prefixNode ? "flex-1 rounded-r" : "rounded", !!errorMessage && _styles_common__WEBPACK_IMPORTED_MODULE_6__/* .textInputError */ .kM, styles === null || styles === void 0 ? void 0 : styles.input, className)
                    }))
                ]
            }),
            hintText && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_text_text__WEBPACK_IMPORTED_MODULE_7__/* .Text */ .x, {
                variant: "secondary",
                size: "sm",
                className: "mt-1.5",
                children: hintText
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(framer_motion__WEBPACK_IMPORTED_MODULE_8__/* .AnimatePresence */ .M, {
                children: errorMessage && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(framer_motion__WEBPACK_IMPORTED_MODULE_9__.m.p, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, _animation__WEBPACK_IMPORTED_MODULE_10__/* .easeInOutOpacity */ .k), {
                    role: "alert",
                    className: "mt-1.5 text-sm leading-none text-red-900",
                    children: errorMessage
                }))
            })
        ]
    });
});


/***/ }),

/***/ 84805:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "r": function() { return /* binding */ useAsync; }
});

// EXTERNAL MODULE: ../../node_modules/.pnpm/react@18.2.0/node_modules/react/index.js
var react = __webpack_require__(52983);
;// CONCATENATED MODULE: ../../packages/ui/src/hooks/use-is-unmounting-ref.ts

function useIsUnmountingRef() {
    const isUnmountingRef = react.useRef(false);
    react.useEffect(()=>{
        return ()=>{
            isUnmountingRef.current = true;
        };
    }, []);
    return isUnmountingRef;
}

;// CONCATENATED MODULE: ../../packages/ui/src/hooks/use-mounted-promise.ts


/**
 * Resolve promise only when component is mounted,
 * fix React setState on unmount warning
 * @returns
 */ function useMountedPromise() {
    const isUnmountingRef = useIsUnmountingRef();
    return react.useCallback((promise)=>new Promise((resolve, reject)=>{
            const onValue = (value)=>{
                !isUnmountingRef.current && resolve(value);
            };
            const onError = (error)=>{
                !isUnmountingRef.current && reject(error);
            };
            promise.then(onValue, onError);
        }), // eslint-disable-next-line react-hooks/exhaustive-deps
    []);
}

;// CONCATENATED MODULE: ../../packages/ui/src/hooks/use-async.ts


/**
 * Async function hooks
 * @param asyncFunction
 * @param immediate Call the function immediately
 * @returns
 */ function useAsync(asyncFunction) {
    let immediate = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
    const [status, setStatus] = react.useState("idle");
    const [data, setData] = react.useState(null);
    const [error, setError] = react.useState(null);
    const asyncFuncRef = react.useRef(asyncFunction);
    react.useEffect(()=>{
        asyncFuncRef.current = asyncFunction;
    });
    const mountedPromise = useMountedPromise();
    const execute = react.useCallback(async ()=>{
        setStatus("pending");
        setData(null);
        setError(null);
        try {
            const response = await mountedPromise(asyncFuncRef.current());
            setData(response);
            setStatus("success");
        } catch (error) {
            setError(error);
            setStatus("error");
        }
    }, [
        mountedPromise
    ]);
    react.useEffect(()=>{
        if (immediate) {
            execute();
        }
    }, [
        execute,
        immediate
    ]);
    const reset = react.useCallback(()=>{
        setStatus("idle");
        setData(null);
        setError(null);
    }, []);
    return {
        execute,
        status,
        data,
        error,
        reset
    };
}


/***/ }),

/***/ 57543:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "c": function() { return /* binding */ useForm; }
});

// EXTERNAL MODULE: ../../node_modules/.pnpm/@swc+helpers@0.4.11/node_modules/@swc/helpers/src/_object_spread.mjs + 1 modules
var _object_spread = __webpack_require__(32641);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@swc+helpers@0.4.11/node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(93089);
// EXTERNAL MODULE: ../../node_modules/.pnpm/react@18.2.0/node_modules/react/index.js
var react = __webpack_require__(52983);
;// CONCATENATED MODULE: ../../packages/ui/src/hooks/use-form/validate.ts
function validate(validator, value) {
    let errorMessage = "";
    if (validator.required && !value) {
        errorMessage = validator.required.message;
    }
    if (validator.pattern) {
        if (typeof validator.pattern.value === "function" && !validator.pattern.value(value)) {
            errorMessage = validator.pattern.message;
        }
        if (validator.pattern.value instanceof RegExp && !validator.pattern.value.test(value)) {
            errorMessage = validator.pattern.message;
        }
    }
    if (validator.maxLength && value.length > validator.maxLength.value) {
        errorMessage = validator.maxLength.message;
    }
    if (validator.minLength && value.length < validator.minLength.value) {
        errorMessage = validator.minLength.message;
    }
    return errorMessage;
}

;// CONCATENATED MODULE: ../../packages/ui/src/hooks/use-form/use-form.ts




function useForm(param) {
    let { defaultValues  } = param;
    const [fields, setFields] = react.useState(defaultValues || {});
    const [errors, setErrors] = react.useState({});
    const validatorMapRef = react.useRef(new Map());
    const isValid = function(name, validator) {
        let value = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : fields[name];
        const errorMessage = validate(validator, value);
        if (errorMessage !== errors[name]) {
            setErrors((prev)=>(0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, prev), {
                    [name]: errorMessage
                }));
        }
        return !errorMessage;
    };
    const register = (name, validator)=>{
        if (validator) {
            validatorMapRef.current.set(name, validator);
        }
        const onChange = (e)=>{
            const { value  } = e.target;
            setFields((prev)=>(0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, prev), {
                    [name]: value
                }));
            if (validator) {
                isValid(name, validator, value);
            }
        };
        return (0,_object_spread/* default */.Z)({
            onChange,
            name,
            value: fields[name]
        }, (validator === null || validator === void 0 ? void 0 : validator.required) && {
            required: true
        });
    };
    const handleSubmit = (onSubmit)=>{
        const onSubmitWrapper = async (e)=>{
            for (const [name, validator] of validatorMapRef.current.entries()){
                if (!isValid(name, validator)) {
                    return;
                }
            }
            await onSubmit(fields, e);
            setFields(defaultValues);
        };
        return onSubmitWrapper;
    };
    const hasError = react.useMemo(()=>{
        return Object.values(errors).some((val)=>{
            return ((val === null || val === void 0 ? void 0 : val.length) || 0) > 0;
        });
    }, [
        errors
    ]);
    const setError = (name, error)=>{
        setErrors((prev)=>(0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, prev), {
                [name]: error
            }));
    };
    return {
        register,
        errors,
        handleSubmit,
        hasError,
        setError,
        setFields
    };
}


/***/ }),

/***/ 6460:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "h": function() { return /* binding */ isValidDomain; },
/* harmony export */   "i": function() { return /* binding */ EMAIL_REGEXP; }
/* harmony export */ });
const EMAIL_REGEXP = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
function isValidDomain(domain) {
    try {
        const url = new URL("https://".concat(domain));
        return url.hostname === domain;
    } catch (e) {
        return false;
    }
}


/***/ }),

/***/ 22357:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"mainImage":"sign-in-form_mainImage__ZlfR8"};

/***/ }),

/***/ 11327:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "d": function() { return /* binding */ F; },
/* harmony export */   "f": function() { return /* binding */ k; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52983);
/* harmony import */ var _hooks_use_id_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(85798);
/* harmony import */ var _utils_render_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(78314);
/* harmony import */ var _hooks_use_iso_morphic_effect_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(27406);
/* harmony import */ var _hooks_use_sync_refs_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(20169);
/* harmony import */ var _hooks_use_event_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(48861);
let d=(0,react__WEBPACK_IMPORTED_MODULE_0__.createContext)(null);function u(){let r=(0,react__WEBPACK_IMPORTED_MODULE_0__.useContext)(d);if(r===null){let t=new Error("You used a <Description /> component, but it is not inside a relevant parent.");throw Error.captureStackTrace&&Error.captureStackTrace(t,u),t}return r}function k(){let[r,t]=(0,react__WEBPACK_IMPORTED_MODULE_0__.useState)([]);return[r.length>0?r.join(" "):void 0,(0,react__WEBPACK_IMPORTED_MODULE_0__.useMemo)(()=>function(e){let i=(0,_hooks_use_event_js__WEBPACK_IMPORTED_MODULE_1__/* .useEvent */ .z)(n=>(t(o=>[...o,n]),()=>t(o=>{let c=o.slice(),p=c.indexOf(n);return p!==-1&&c.splice(p,1),c}))),s=(0,react__WEBPACK_IMPORTED_MODULE_0__.useMemo)(()=>({register:i,slot:e.slot,name:e.name,props:e.props}),[i,e.slot,e.name,e.props]);return react__WEBPACK_IMPORTED_MODULE_0__.createElement(d.Provider,{value:s},e.children)},[t])]}let S="p",F=(0,_utils_render_js__WEBPACK_IMPORTED_MODULE_2__/* .forwardRefWithAs */ .yV)(function(t,a){let e=u(),i=`headlessui-description-${(0,_hooks_use_id_js__WEBPACK_IMPORTED_MODULE_3__/* .useId */ .M)()}`,s=(0,_hooks_use_sync_refs_js__WEBPACK_IMPORTED_MODULE_4__/* .useSyncRefs */ .T)(a);(0,_hooks_use_iso_morphic_effect_js__WEBPACK_IMPORTED_MODULE_5__/* .useIsoMorphicEffect */ .e)(()=>e.register(i),[i,e.register]);let n=t,o={ref:s,...e.props,id:i};return (0,_utils_render_js__WEBPACK_IMPORTED_MODULE_2__/* .render */ .sY)({ourProps:o,theirProps:n,slot:e.slot||{},defaultTag:S,name:e.name||"Description"})});


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [107,606,128,747,774,888,179], function() { return __webpack_exec__(72951); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);